
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'

// 新增任务
export function addTask(params) {
    return post(`${HOST}task/save`, params)
}
//任务列表
export function getTask(params) {
    return get(`${HOST}task/get`, params)
}
// 新增审计报告
export function addAuditReportRectification(params) {
    return post(`${HOST}audit-report-rectification/save`, params)
}

// 修改审计报告
export function updateAuditReportRectification(params) {
    return post(`${HOST}audit-report-rectification/update`, params)
}
//审计报告列表
export function getAuditReportRectification(params) {
    return get(`${HOST}audit-report-rectification/list/`, params)
}
//审计报告草稿箱列表
export function AuditReportRectificationDraftlist(params) {
    return get(`${HOST}audit-report-rectification/draftlist`, params)
}
//审计报告详情
export function AuditReportRectificationDetial(params) {
    return get(`${HOST}audit-report-rectification/get/`, params)
}
// 删除审计报告
export function delAuditReportRectification(params) {
    return del(`${HOST}audit-report-rectification/delete`, params)
}

//我发起的整改任务
export function taskGetUserList(params) {
    return get(`${HOST}/task/getUserList`, params)
}

// 删除我发起的整改任务
export function taskDelete(params) {
    return del(`${HOST}/task/delete`, params)
}




// WEBPACK FOOTER //
// ./src/views/standingBook/api/api.js